import {Component, ViewChild} from '@angular/core';
import {AlertController, ModalController, NavController, NavParams} from "ionic-angular";
import {BysalesrepPage} from "../bysalesrep/bysalesrep";
import {Chart} from 'chart.js';
import {Api} from "../../providers/api";
import {CartManager} from "../../providers/cart-manager";
import {MsgManager} from "../../providers/msg-manager";
import {DatePickerProvider} from "ionic2-date-picker";
import {ApiOffline} from "../../providers/api-offline";
import {GVLogger} from "../../services/gv-logger";

@Component({
  selector: 'page-closedsales',
  templateUrl: 'closedsales.html',
})
export class ClosedsalesPage {
  salesRepCheck: any;
  pSalesCheck: any;
  pProductsCheck: any;
  pieChart: any;

  myChart:any;

  pieActive: any = true;
  @ViewChild('pieCanvas') pieCanvas;

  data: any = {
    labels: [],
    // labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange", "new", "one more"],
    datasets: [{
      label: '# of Votes',
      data: [],
      // data: [12, 19, 3, 5, 2, 3,9, 20],
      backgroundColor: [
        // 'rgba(255, 99, 132, 0.2)'
      ],
      hoverBackgroundColor: [
        // "#FF6384",
      ]
    }]
  };
  private bySaleRep: any;
  private totalSaleRep: any;
  private startDate: any;
  private endDate: any;
  private orderStatus: any;
  private byProduct: any;
  private totalCustomer: number;
  private totalProduct: any;
  private byCustomer: any;
  private salePerson: any;

  constructor(public navCtrl: NavController, public navParams: NavParams, public api: Api, private cartManager: CartManager,
              public alertCtrl: AlertController,
              public msgManager: MsgManager,
              private gVLogger: GVLogger,
              private apiOffline: ApiOffline,
              private modalCtrl: ModalController,
              private datePickerProvider: DatePickerProvider) {
    this.pSalesCheck = true;
    this.salePerson = this.cartManager.getSalesPerson();

    let year = new Date().getFullYear();
    this.startDate = year + "-01-01";
    let month = '';
    let day = '';
    let mm: any = new Date().getMonth()+1;
    let dd: any = new Date().getDate();

    if (dd > 0 && dd < 10) {
      dd = "0" + dd;
    }
    if (mm > 0 && mm < 10) {
      mm = "0" + mm;
    }
    this.endDate = new Date().getFullYear() + "-" + mm + "-" + dd;

    // this.gVLogger.log("this.endDatethis.endDate", this.endDate);


    this.orderStatus = 1;
    this.BySaleRep();
    setTimeout(() => {
      this.ByCustomer();
      setTimeout(() => {
        this.ByProduct();
      }, 100);
    }, 30);

  }



  ionViewDidLoad() {
    this.gVLogger.log('ionViewDidLoad BysalesrepPage');
    this.pieChartMethod();


  }


  pieChartMethod() {
    setTimeout(() => {
      var ctx = <HTMLCanvasElement> document.getElementById("pieCanvas");
      this.pieCanvas = ctx.getContext('2d');
      this.myChart = new Chart(this.pieCanvas, {
        type: 'pie',
        data: this.data,
        options: {
          legend: {
            display: true,
            position: 'left',
            labels: {
              // fontColor: 'rgb(255, 99, 132)'
            }
          }
        }
      });
    }, 80);
  }


  bySalesRepBtn() {
    this.salesRepCheck = true;
    this.pSalesCheck = false;
    this.pProductsCheck = false;


  }

  byCustomerBtn() {
    this.salesRepCheck = false;
    this.pSalesCheck = true;
    this.pProductsCheck = false;
    this.pieChartMethod();
  }

  byProductsBtn() {
    this.salesRepCheck = false;
    this.pSalesCheck = false;
    this.pProductsCheck = true;
  }

  showhidePie() {
    if (this.pieActive)
      this.pieActive = false;
    else {
      this.pieActive = true;
      if(this.byCustomer.length <= 0){
        this.myChart.destroy();
      }else{
      this.pieChartMethod();
      }
    }

  }


  BySaleRep() {
    let userId = this.cartManager.getSalesManId();
    this.gVLogger.log(this.salePerson.restrictToAssignedCustomers+ "sales person");
    this.gVLogger.log("userId"+ userId);
    let body = {
      startDate: new Date(this.startDate),
      endDate: new Date(this.endDate),
      orderStatus: this.orderStatus,
      userID: userId
    };

    let pathToApi = '';
    if(this.salePerson.restrictToAssignedCustomers == 0){
      pathToApi = 'reports/potentialaccounts/bysalerep'
    }
    if(this.salePerson.restrictToAssignedCustomers == 1){
      pathToApi = 'reports/app/potentialaccounts/bysalerep';
    }
    this.api.postlocal(pathToApi, body)
      .subscribe(res => {
        this.bySaleRep = res.json();
        this.totalSaleRep = this.bySaleRep.length;
        this.gVLogger.log(this.bySaleRep+ this.totalSaleRep);
      });
  }


  ByCustomer() {
    let userId = this.cartManager.getSalesManId();
    this.gVLogger.log("userId"+ userId);
    let body = {
      startDate: new Date(this.startDate),
      endDate: new Date(this.endDate),
      orderStatus: this.orderStatus,
      userID: userId
    };
    let pathToApi = '';
    if(this.salePerson.restrictToAssignedCustomers == 0){
      pathToApi = 'reports/potentialaccounts/bycustomer'
    }
    if(this.salePerson.restrictToAssignedCustomers == 1){
      pathToApi = 'reports/app/potentialaccounts/bycustomer';
    }
    this.api.postlocal(pathToApi, body)
      .subscribe(res => {
        this.byCustomer = res.json();
        this.totalCustomer = this.byCustomer.length;
        this.gVLogger.log(body+ "byCustomer"+ this.byCustomer);


        for (let i = 0; i < this.totalCustomer; i++) {
          this.data.labels[i] = (this.byCustomer[i].cutomerName);
          this.data.datasets[0].data[i] = (this.byCustomer[i].total_amount);
          let r = Math.floor(Math.random() * 250);
          let g = Math.floor(Math.random() * 250);
          let b = Math.floor(Math.random() * 250);
          let a = Math.floor(Math.random() * 250);
          this.data.datasets[0].backgroundColor[i] = 'rgba('+r+', '+g+', '+b+', 0.2)';
          this.data.datasets[0].hoverBackgroundColor[i] = 'rgba('+r+', '+g+', '+b+', 1)';
          // this.gVLogger.log( "this.byCustomer.cutomerName", this.byCustomer[i].cutomerName);
        }

        if(this.byCustomer.length > 0){
         this.pieChartMethod();
        }

      }, err => {

      });
  }

  ByProduct() {
    let userId = this.cartManager.getSalesManId();
    this.gVLogger.log("userId"+ userId);
    let body = {
      startDate: new Date(this.startDate),
      endDate: new Date(this.endDate),
      orderStatus: this.orderStatus,
      userID: userId
    };
    let pathToApi = '';
    if(this.salePerson.restrictToAssignedCustomers == 0){
      pathToApi = 'reports/potentialaccounts/byproduct'
    }
    if(this.salePerson.restrictToAssignedCustomers == 1){
      pathToApi = 'reports/app/potentialaccounts/byproduct';
    }
    this.api.postlocal(pathToApi, body)
      .subscribe(res => {
        this.byProduct = res.json();
        this.totalProduct = this.byProduct.length;
        this.gVLogger.log(body+ "byProduct"+this.byProduct);
      }, err => {

      });
  }


  showCalendarEnd() {

    const dateSelected = this.datePickerProvider.showCalendar(this.modalCtrl);


    dateSelected.subscribe(date => {
      this.gVLogger.log(date);
      var d = new Date("" + date);
      let dd: any = d.getDate();
      if (dd > 0 && dd < 10) {
        dd = "0" + dd;
      }
      let mm: any = d.getMonth() + 1; //January is 0!
      if (mm > 0 && mm < 10) {
        mm = "0" + mm;
      }
      var output = d.getFullYear() + "-" + mm + "-" + dd;
      this.endDate = output;
    });
  }

  showCalendarStart() {

    const dateSelected = this.datePickerProvider.showCalendar(this.modalCtrl);


    dateSelected.subscribe(date => {
      this.gVLogger.log(date);
      var d = new Date("" + date);
      let dd: any = d.getDate();
      if (dd > 0 && dd < 10) {
        dd = "0" + dd;
      }
      let mm: any = d.getMonth() + 1; //January is 0!
      if (mm > 0 && mm < 10) {
        mm = "0" + mm;
      }
      var output = d.getFullYear() + "-" + mm + "-" + dd;
      this.startDate = output;

    });
  }

  shipDateChanged() {
    this.myChart.destroy();
    this.BySaleRep();
    setTimeout(() => {
      this.ByCustomer();
      setTimeout(() => {
        this.ByProduct();
      }, 100);
    }, 30);
  }

}



// WEBPACK FOOTER //
// ./src/pages/closedsales/closedsales.ts